export const isIE =
  typeof window !== 'undefined' &&
  '-ms-scroll-limit' in document.documentElement.style &&
  '-ms-ime-align' in document.documentElement.style;



// WEBPACK FOOTER //
// ./src/util/isIE.js